<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="85%" :show-close="false" :offset="0" class="price-dialog">
      <div class="content">
        <div class="befor">
          <div class="topCar">
            <p>产品详情及报价维护</p>
            <div>
              <el-input v-model="productName" @change="searchData" placeholder="产品名称" style="width:1.5rem;margin-right: 0.1rem;" size="mini"></el-input>
            </div>
            <div class="an">
              <span class="span1" @click="save">保存</span>
              <span class="span2" @click="closeDialog">关闭</span>
            </div>
          </div>
        </div>
        <div class="cen">
          <div class="Le">
            <p v-if="budget.state>-1">{{stockTypeMap[budget.state].typeName}}</p>
          </div>
          <div class="Lcen">
            <el-table border ref="singleTable" :data="tableList" highlight-current-row size="mini" :span-method="objectSpanMethod" class="table1">
              <el-table-column property="staydate" label="使用日期" width="89" height="48">
                <template slot-scope="scope">
                  {{scope.row.stayDateStr}}
                </template>
              </el-table-column>
              <el-table-column label="产品名称" width="160" show-overflow-tooltip sortable prop="productName">
                <template slot-scope="scope">
                  <span class="hiddenText" :style="scope.row.stockId==chooseStockId?'box-shadow: 0px 2px 6px 0px #296776;border: 1px solid #296776;':''">
                    {{scope.row.productName}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column property="cityName" label="使用城市" width="60">
              </el-table-column>
              <el-table-column property="servicedescribe" label="产品说明" width="93" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.stockDetail.productDesc}}</span>
                </template>
              </el-table-column>
              <el-table-column label="单价(原币)" width="73" sortable prop="stockPrice">
                <template slot-scope="scope">
                  <span>{{scope.row.status ==0 ?scope.row.stockPrice :0}}{{scope.row.currency}} </span>
                </template>
              </el-table-column>
              <el-table-column label="单位" width="42">
                <template slot-scope="scope">
                  <span>{{scope.row.stockDetail.priceList[0].priceCompany}}</span>
                </template>
              </el-table-column>
              <el-table-column label="时长" width="46">
                <template slot-scope="scope">
                  <span>{{scope.row.stockDetail.priceList[0].timeDesc?scope.row.stockDetail.priceList[0].timeDesc:
                scope.row.stockDetail.priceList[0].useTime}}</span>
                </template>
              </el-table-column>
              <el-table-column property="servicenumber" label="数量" width="38">
                <template slot-scope="scope" >
                  <div v-if="scope.row.orderBudgetId">
                    {{scope.row.stockNumber}}
                  </div>
                  <div v-else>
                    <input type="number" v-if="scope.row.status ==0? true :false"  @change="changeNumber(scope.row)"
                      style="width: 0.29rem;font-size: 0.12rem;border: none;" v-model="scope.row.stockNumber"/>
                  </div>    
                </template>                
              </el-table-column>
              <el-table-column property="address" label="总价(原币)" width="65">
                <template slot-scope="scope">
                  {{scope.row.status ==0 ? Number((scope.row.stockNumber * scope.row.stockPrice).toFixed(2)) :0}}{{scope.row.currency}}
                </template>
              </el-table-column>
              <el-table-column property="rate" label="汇率" width="35" v-if="budget.currency==='￥' ? false : true">
                <template slot-scope="scope">
                  <input v-if="scope.row.status ==0  ? true :false"  @change="changeRate(scope.row)"
                    style="width: 0.29rem;font-size: 0.12rem;border: none;" v-model="scope.row.rate"/>
                </template>
              </el-table-column>
              <el-table-column property="address" label="总价(人民币)" width="78" v-if="budget.currency==='￥' ? false : true">
                <template slot-scope="scope">
                  <span>{{(scope.row.status ==0 ?scope.row.stockNumber * scope.row.stockPrice * scope.row.rate :0).toFixed(2)}}￥</span>
                </template>
              </el-table-column>
              <el-table-column label="票据号" width="78" sortable prop="stockDetail.billNumber">
                <template slot-scope="scope">
                  <span>{{scope.row.stockDetail.billNumber}}</span>
                </template>
              </el-table-column>
              <el-table-column property="address" label="操作" width="126">
                <template slot-scope="scope">
                  <div style="display: flex;"> 
                    <el-button type="text">
                      <svg-icon :iconClass="scope.row.status==0?'eye-close':'eye-open'" class="zp" @click="Conversionstatus(scope.$index, scope.row)"></svg-icon>
                    </el-button>
                    <el-button type="text">
                      <i class="el-icon-delete zp" v-if="!scope.row.orderBudgetId" style="color: #2C2C2C;" @click="deleteBudget(scope.row,scope.$index)"></i>
                    </el-button>
                    <el-button type="text">
                      <button class="zp1" @click="chaifen(scope.row)">拆</button>
                    </el-button>
                    <el-button type="text">
                      <button class="zp1" v-if="!scope.row.orderBudgetId" @click="singleCreateOrder(scope.row)">订</button>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="lfoot">
              <div class="pbian">
                <p>合计</p>
              </div>
              <div style="display:flex">
                <div class="lfootC">
                  <p class="lfootCP1">
                    <span class="cp2" v-for="(item,index) in numPrice" :key="index">{{item.price}}{{item.currency}}</span>
                  </p>
                </div>
                <div class="lfootR">
                  <p>
                    <span class="p1235">
                      <svg-icon :iconClass="'kefu'" style="width: 0.18rem;height: 0.18rem;"></svg-icon>
                      <span class="p1">总额</span>
                      <span class="variety"> {{'￥'+ Number(sumPrice.toFixed(2))}}</span>
                      <button class="p3" @click="allCreateOrder">预 订</button>
                    </span>
                    <button class="p4">
                      <div>查看优惠卷</div>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="Rig">
            <div class="slider">
              <el-table class="table2" :data="tableList" :cell-style="rowStyle" :header-cell-style="tableHeaderColor">>
                <el-table-column property="companyname" label="单项报价(原币)" width="90">
                  <template slot-scope="scope" v-if=" scope.row.status ==0 ?true :false">
                    <div v-if="!scope.row.orderBudgetId">
                      <input type="number" @change="changeNum($event,scope.row)"
                             :value=" scope.row.status ==0 ? scope.row.ratio: 0"/>
                      {{scope.row.currency}}
                      <i @click="copyPrice(scope.row)" v-if="scope.$index==0" class="el-icon-document-copy"></i>
                    </div>
                    <div v-else>
                      {{scope.row.ratio}}{{scope.row.currency}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="companyname" label="单项利润(原币)" width="75">
                  <template slot-scope="scope" v-if=" scope.row.status ==0 ?true :false">
                    <div v-if="!scope.row.orderBudgetId">
                      <input type="number"
                             :value="scope.row.status ==0 ?Number((scope.row.ratio-scope.row.stockPrice).toFixed(2)) :0" @change="profit($event,scope.row)" />
                    </div>
                    <div v-else>
                      {{Number((scope.row.ratio-scope.row.stockPrice).toFixed(2))}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="yb" label="单项利(润率)" width="59">
                  <template slot-scope="scope" v-if=" scope.row.status ==0 ?true :false">
                    <div v-if="!scope.row.orderBudgetId">
                      <input type="text"
                             :value=" scope.row.status ==0 ?(((scope.row.ratio-scope.row.stockPrice) / scope.row.ratio) * 100).toFixed(2) :0"
                             @change="profitlv($event,scope.row)" />%
                    </div>
                    <div v-else>
                      {{(((scope.row.ratio-scope.row.stockPrice) / scope.row.ratio) * 100).toFixed(2) }}%
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="zbj" label="总报价(原币)" width="85" v-if="budget.currency==='￥' ? false : true">
                  <template slot-scope="scope">
                    <span>{{(scope.row.status ==0 ?scope.row.ratio *scope.row.stockNumber :0).toFixed(2)}}{{budget.currency}}</span>
                  </template>
                </el-table-column>
                <el-table-column property="zbj" label="总报价(人民币)" width="105">
                  <template slot-scope="scope">
                    <span>
                      {{(scope.row.status ==0 ?scope.row.ratio * scope.row.rate *scope.row.stockNumber :0).toFixed(2)}}￥
                    </span>
                  </template>
                </el-table-column>
                <el-table-column property="zlr" label="总利润(人民币)" width="71">
                  <template slot-scope="scope">
                    <span>{{(scope.row.status ==0 ?scope.row.ratio * scope.row.rate *scope.row.stockNumber - scope.row.stockNumber * scope.row.stockPrice * scope.row.rate :0).toFixed(2)}}￥</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="silafter">
              <div class="afL">
                <span class="s3" v-for="(item,index) in Totaloffer" :key="index">{{item.price.toFixed(2)}}{{item.currency}}</span>
              </div>
              <div class="afC">
                <div><span class="s1">{{(TotalofferRmb).toFixed(2)}}</span><span class="s2">￥</span></div>
                <div><span class="s4"> 报价</span></div>
              </div>
              <div class="afR">
                <div>
                  <span class="s4">利润&nbsp;</span>
                  <span class="sm1">{{(TotalofferRmb-sumPrice).toFixed(2)}}</span>
                  <span class="s6">￥</span>
                </div>
                <div>
                  <span class="s4">利润率&nbsp;</span>
                  <span class="s5">{{((TotalofferRmb-sumPrice)/TotalofferRmb*100).toFixed(2)}}</span><span class="s2">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="after" v-if="productStockList.length>0">
          <svg-icon :iconClass="'arrowhead-left'" class="zpleft" style="left:0"></svg-icon>
          <svg-icon :iconClass="'arrowhead-right'" class="zpleft" style="right:0"></svg-icon>
          <div style="margin: 0.26rem 0.17rem 0.2rem 0.43rem;display:flex">
            <div class="Lbox" v-for="(pp,index) in productStockList" :key="index" @click="changeStock(pp)"
              :style="pp.id==chooseStockId?'box-shadow: 0px 2px 6px 0px #296776;border: 1px solid #296776;':''">
              <stock-detail :stockDetailObj="pp" :productType="budget.productType==1||budget.productType==5?1:2"></stock-detail>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <createPreOrder ref="orderPre"></createPreOrder>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import {stockTypeMap} from '@/assets/utils/commonData'
import {refresh} from "../../js/function"
import stockDetail from "./stockDetail.vue";
import createPreOrder from "@/views/plan/leftMoudle/dialog/createPreOrder.vue";
export default {
  components: {createPreOrder, stockDetail },
  data(){
    return{
      dialogVisible:false,
      budget:{},
      tableList:[],
      stockTypeMap,
      chooseStockId:null,
      sumPrice:0,
      numPrice:[],
      marketPrice:0,
      Totaloffer:[],
      TotalofferRmb:0,
      changeTableList:[],
      productStockList:[],
      newBudgetMainId:null,
      productName:'',
      oldList:[],
    }
  },
  props:{
    checkBudget:{
      type:Object,
      default:()=>{return {}}
    },
  },
  methods:{
    searchData(){
      if(this.productName==''){
        this.tableList=this.oldList
      }else{
        var arr=[]
        this.tableList.forEach(ee=>{
          if(this.productName!=''&&this.productName==ee.productName){
            arr.push(ee)
          }
        })
        this.tableList = arr
      }
    },
    chaifen(item){
      var obj = JSON.parse(JSON.stringify(item))
      obj.id = null
      var index = this.tableList.findIndex(e=>e.id==item.id)
      this.changeTableList.push(obj)
      this.tableList.splice(index+1,0,obj)
    },
    // 全部下订单
    allCreateOrder() {
      let arr = this.tableList.filter(x => x.status === 0 && !x.orderBudgetId)
      console.log('allCreateOrder',arr)
      let budgetIds = []
      arr.forEach(data => {
        // if (data.linkBudgetIds && data.linkBudgetIds.length > 0) {
        //   budgetIds.push(...data.linkBudgetIds)
        // } else {
        //   budgetIds.push(data.id)
        // }
        budgetIds.push(data.id)
      })
      if(budgetIds.length === 0) {
        this.$message({type:"warning",message:"商品全部已定！"})
          return 
      }
      this.$refs.orderPre.init([...budgetIds,-1], 0)
    },
    // 单个"订"下订单
    singleCreateOrder(data) {
      console.log("singleCreateOrder",data)
      let budgetIds = []
      // if (data.linkBudgetIds && data.linkBudgetIds.length > 0) {
      //   budgetIds.push(...data.linkBudgetIds)
      // } else {
      //   budgetIds.push(...data.budgetIds)
      // }
      budgetIds.push(data.id)
      
      this.$refs.orderPre.init([...budgetIds,-1], 0)
    },
    closeDialog(){
      this.dialogVisible=false
      if(this.newBudgetMainId){
        refresh(this.newBudgetMainId,this.$store.state.planId,this.$store.state.budgetMainId,'')
      }
    },
    save(){
      new PlanApi('plan').updateBudgetDetail({
        id:this.checkBudget.id,
        useNumber:this.checkBudget.useNumber,
        details:this.changeTableList
      }).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"保存成功"})
          this.dialogVisible = false
          res.data.addCitySize=0
          this.changeTableList = []
          if(res.data!=''){
            refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'')
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    copyPrice(item){
      this.tableList.forEach(e=>{
        this.$set(e,'ratio',item.ratio)
        this.changeTableList.push(e)
      })
    },
    Conversionstatus(index, e){
      if (e.status == 0) {
        e.status = 1
      } else {
        e.status = 0
      }
      this.changeNumber(index,e)
    },
    rowStyle ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#e3f5f9'
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color:#e3f5f9'
      }
    },
    ItemGroupBy (arr, key) {
      let newArr = [],types = {}, newItem, i, j, cur;
      for (i = 0, j = arr.length; i < j; i++) {
        cur = arr[i];
        if (!(cur[key] in types)) {
          types[cur[key]] = { type: cur[key], data: [] };
          newArr.push(types[cur[key]]);
        }
        types[cur[key]].data.push(cur);
      }
      return newArr;
    },
    postTableListData(){
      new PlanApi('plan').oneBudgetDetailList({
        budgetMainId:this.checkBudget.id,
        state:this.budget.state,
        resourceId:this.budget.resourceId,
        productType:this.budget.productType,
      }).then(res => {
        if (res.status == 200) {
          var list = res.data.budgetList.filter(e=>e.stockId!==0).map(e=>e.stockId)
          if(list.length>0){
            var stockIds = [...new Set(list)]
            new Api('resource').stockDetail({stockIds:stockIds,productType:this.budget.productType==1||this.budget.productType==5?1:2}).then(res => {
              if (res.status == 200) {
                this.productStockList = res.data
                this.chooseStockId = res.data[0].id
              }
            })
          }
          res.data.budgetList.forEach(element => {
            // this.$set(element,'stayDate',this.dateFormatYMD(element.stayDate,"-"))
            if(this.budget.details[0].isInquirySend==1){
              this.$set(element,'orderBudgetId',1)
            }
            if(element.stockDetail&&element.stockDetail!=''){
              this.$set(element,'stockDetail',JSON.parse(element.stockDetail))
            }else{
              this.$set(element,'stockDetail',{"priceList":[{}]})
            }
          });
          this.tableList = res.data.budgetList
          this.oldList = this.tableList
          this.changeNumber()
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    openDialog(item){
      this.dialogVisible = true
      this.budget = item
      this.postTableListData()
    },
    objectSpanMethod ({ rowIndex, columnIndex }) {
      var is = this.ItemGroupBy(this.tableList, 'stayDateStr')
      let i = 0
      for (var p = 0; p < is.length; p++) {
        if (columnIndex === 0) {
          if (rowIndex === i) {
            return {
              rowspan: is[p].data.length,
              colspan: 1
            }
          }
          for (var k = 0; k < is[p].data.length; k++) {
            if (rowIndex === i + (is[p].data.length - (k + 1))) {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
          i = i + is[p].data.length
        }
      }
    },
    changeNum(evt, item){
      item.ratio = evt.target.value
      this.changeRadio(item)
    },
    profit(evt, item){
      item.ratio = item.stockPrice+Number(evt.target.value)
      this.changeRadio(item)
    },
    profitlv(evt, item){
      item.ratio = item.stockPrice/(1-evt.target.value/100)
      this.changeRadio(item)
    },
    changeBaoJia(){
      this.Totaloffer=[]
      this.TotalofferRmb=0
       if (this.tableList.length > 0) {
        this.tableList.forEach((item, index) => {
          if (item.status == 0) {
            var numPriceObj = this.Totaloffer.find(ee=>ee.currency==item.currency)
            if(numPriceObj){
              numPriceObj.price = numPriceObj.price+item.stockPrice*item.stockNumber
            }else{
              this.Totaloffer.push({
                price:item.stockPrice*item.stockNumber,
                currency:item.currency
              })
            }
            this.TotalofferRmb= this.TotalofferRmb+(item.ratio*item.stockNumber*item.rate)
          }
        })
      }
    },
    changeRadio(val){
      if(val&&val.id&&this.changeTableList.filter(c=>c.id==val.id).length==0){
        this.changeTableList.push(val)
      }
      this.changeBaoJia()
    },
    changeRate(item){
      if(item.oldRate>item.rate){
        item.rate = item.oldRate
        this.$message({type:"error",message:"更改汇率不能小于原汇率"})
      }else{
        this.changeNumber(item)
      }
    },
    changeNumber (item) {
      this.sumPrice=0
      this.numPrice=[]
      if (this.tableList.length > 0) {
        this.tableList.forEach((item, index) => {
          if (item.status == 0) {
            var numPriceObj = this.numPrice.find(ee=>ee.currency==item.currency)
            if(numPriceObj){
              numPriceObj.price = numPriceObj.price+item.stockPrice*item.stockNumber
            }else{
              this.numPrice.push({
                price:item.stockPrice*item.stockNumber,
                currency:item.currency
              })
            }
            this.sumPrice= this.sumPrice+(item.stockPrice*item.stockNumber*item.rate)
          }
        })
      }
      this.changeRadio(item)
    },
    deleteBudget(item,index){
      this.$confirm('如确定删除，该数据将被实时删除（无需点击保存）。', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetDelete({budgetMainId:[this.checkBudget.id],budgetDetailIds:[item.id],budgetIds:[item.budgetId]}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"删除成功"})
            if(!this.newBudgetMainId){
              this.newBudgetMainId = res.data
            }
            this.postTableListData()
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    }
  }

}
</script>

<style lang="scss" scoped>
.price-dialog /deep/ .el-dialog__header,.price-dialog /deep/ .el-table__cell,.price-dialog /deep/ .cell,.price-dialog /deep/ .el-button{
  padding: 0 !important;
}
.price-dialog /deep/ .cell{
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.price-dialog /deep/ .el-table tr{
  height: 0.49rem;
}
.Lcen{
  /deep/ .el-table__header{
    width: 9.5rem !important;
  }
  /deep/ .el-table__body{
    width: 9.5rem !important;
  }
}
.content {
  box-sizing: border-box;
  .befor {
    .topCar {
      background-color: rgba(255, 255, 255, 100);
      display: flex;
      justify-content: space-between;
      align-items: center;
      //border-bottom: 1px solid #e4e4e4;
      font-weight: bold;
      height: 0.74rem;
      p {
        margin-left: 0.3rem;
        color: rgba(219, 78, 26, 100);
        font-size: 0.18rem;
        font-family: SourceHanSansSC-bold;
      }
      .an {
        margin-right: 0.3rem;
        span {
          border-radius: 4px;
          cursor: pointer;
          padding: 0.08rem 0.23rem;
        }
        .span1 {
          margin-right: 0.1rem;
          color: white;
          background-color: rgba(2, 160, 198, 100);
        }
        .span2 {
          border: 1px solid #e5e5e5;
        }
      }
    }
  }
  .cen {
    display: flex;
    align-items: center;
    padding: 10px 0;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    .zp {
      width: 22px;
      height: 22px;
      background-color: #f0f4f5;
      border-radius: 5px;
      padding: 3px;
    }
    .zp1 {
      width: 0.22rem;
      height: 0.22rem;
      display: inline-block;
      border: #db4e1a;
      background-color: #db4e1a;
      color: #fff;
      border-radius: 5px;
      font-weight: bold;
    }
    .Le {
      font-size: 0.12rem;
      text-align: center;
      width: 0.44rem;
    }
    .lfoot {
      height: 0.48rem;
      display: flex;
      align-items: center;
      padding: 0 1.2rem;
      justify-content: space-between;
      .pbian {
        font-size: 0.12rem;
        p {
          color: #101010;
        }
      }
      .lfootC {
        font-size: 0.12rem;
        transform: scale(0.8);
        text-align: right;
        .cp2 {
          font-size: 0.2rem;
          color: #000;
          font-weight: bold;
        }
        .cp3 {
          color: #686868 90%;
        }
      }
      .lfootR {
        margin-left: 0.05rem;
        p {
          display: flex;
          align-items: center;
          .p1235 {
            padding-left:0.1rem;
            height: 0.32rem;
            display: flex;
            align-items: center;
            border: 1px solid rgba(219, 78, 26, 100);
          }
          .p1 {
            color: #000;
            font-size: 0.12rem;
            margin-left: 0.1rem;
          }
          .p3 {
            width: 0.72rem;
            height: 0.32rem;
            color: #fdfefe;
            font-size: 0.14rem;
            border: 1px solid rgba(219, 78, 26, 100);
            background-color: #db4e1a;
            margin-left: 0.15rem;
          }
          .p4 {
            margin-left: 0.05rem;
            width: 0.56rem;
            height: 0.32rem;
            color: rgba(255, 255, 255, 100);
            font-size: 0.12rem;
            background-color: #02a0c6;
            border: none;
            div {
              transform: scale(0.89);
            }
          }
        }
        .variety {
          font-size: 0.18rem;
          color: #db4e1a;
          font-weight: bold;
        }
      }
    }
    .Rig {
      width: 30%;
      .slider {
        background-color: #e3f5f9;
        margin-left: 0.2rem;
      }
      input{
        width: 60%;
        font-size: 0.12rem;
        border: none;
      }
      .silafter{
        margin-left: 0.2rem;
        display: flex;
        justify-content: space-between;
        height: 0.48rem;
        align-items: center;
        >div{
          text-align: right;
          >div:last-child{
            margin-top: 0.03rem;
          }
        }
        .afL {
          .s2 {
            font-size: 0.12rem;
            color: #02b2dd;
            text-decoration: line-through;
          }
          .s3 {
            font-size: 0.16rem;
            color: #000000;
            font-weight: bold;
          }
          .s4 {
            font-size: 0.12rem;
            color: #615959;
            transform: scale(0.8);
          }
        }
        .s1 {
          font-size: 0.18rem;
          color: #02b2dd;
          font-weight: bold;
        }
        .afC{
          .s4{
            font-size: 0.14rem;
            font-weight: bolder;
            color: #615959;
            transform: scale(0.9);
          }
        }
        .afR{
          .s1 {
            font-size: 0.18rem;
            color: #02b2dd;
            font-weight: bold;
          }
          .s2 {
            font-size: 0.14rem;
            color: #02b2dd;
          }
          .s4 {
            color: #615959;
            transform: scale(0.9);
            font-size: 0.14rem;
            font-weight: bolder;
          }
          .s6 {
            font-size: 0.12rem;
            color: #02b2dd;
          }
          .s5 {
            font-size: 0.12rem;
            color: #02b2dd;
            .s2 {
              font-size: 0.14rem;
              color: #02b2dd;
            }
          }
          .sm1 {
            font-size: 0.15rem;
            color: #02b2dd;
            font-weight: bold;
          }
        }
      }
    }
    .Lcen{
      width: 65%;
    }
  }
  .after {
    position: relative;
    overflow: auto;
    overflow-y: scroll;
    display: flex;
    font-size: 0.14rem;
    color: #000000;
    p{
      margin-left: 20px;
      padding-bottom: 2px;
    }
    &::-webkit-scrollbar {//隐藏滚动条
      display: none;
    }
    .zpleft {
      margin-top: 1rem;
      position: absolute;
      width: 0.47rem;
      height: 0.47rem;
    }
    .Lbox {
      border-radius: 9px;
      width: 3.94rem;
      border: 1px solid rgba(0,0,0,0.06);
      margin-right: 0.15rem;
    }
  }
}
</style>
